export default __webpack_public_path__ + "static/media/help1.25292f01.png";